// #region imports

// --- Angular
import { Component, OnInit } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

  constructor() { }

  ngOnInit() {
   }

}
